module.exports = __webpack_public_path__ + "img/70053d81407d0510409a16bd15ab2c7e.png";